import { render, staticRenderFns } from "./CustomerChooser.vue?vue&type=template&id=6a49b6e9&lang=pug&"
import script from "./CustomerChooser.vue?vue&type=script&lang=js&"
export * from "./CustomerChooser.vue?vue&type=script&lang=js&"
import style0 from "./CustomerChooser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports